var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "y8qy2g6d5a",
    d: "M0 0H19V19H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-773 -221) translate(157 72) translate(50 136) translate(566 13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ggbitxrceb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#y8qy2g6d5a"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#40C706",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    mask: "url(#ggbitxrceb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 18 1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 6.5,
    r: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11.294L0.272 16.685"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenSearchIcon);
export default __webpack_public_path__ + "static/media/green-search-icon.57e4ab11421f426df64df35f063ec56f.svg";
export { ForwardRef as ReactComponent };